import {ElementsFactories} from 'architecrange';

const info = {
  title: 'wall',
  tag: ['wall'],
  description: 'Vertical and horizontal cladding (#e0b88c), brick, or painted',
  image: require('./wall.png'),
  visibility: {
    catalog: true,
    layerElementsVisible: true
  }
};

const CLADDING_BOARD_WIDTH_CM = 14;

const textures = {
  cladding: {
    name: 'Vertical cladding',
    uri: require('./textures/cladding-sand.jpg'),
    computeRepeat(lengthCm, heightCm) {
      let repeatU = Math.max(0.01, lengthCm / CLADDING_BOARD_WIDTH_CM);
      let repeatV = 1;
      return {x: repeatU, y: repeatV};
    }
  },
  logs: {
    name: 'Horizontal cladding',
    uri: require('./textures/cladding-sand.jpg'),
    lengthRepeatScale: 0.003,
    heightRepeatScale: 0.014,
    rotation: Math.PI / 2
  },
  bricks: {
    name: 'Bricks',
    uri: require('./textures/bricks.jpg'),
    lengthRepeatScale: 0.01,
    heightRepeatScale: 0.01,
    normal: {
      uri: require('./textures/bricks-normal.jpg'),
      lengthRepeatScale: 0.01,
      heightRepeatScale: 0.01,
      normalScaleX: 0.8,
      normalScaleY: 0.8
    }
  },
  painted: {
    name:'Painted',
    uri: require('./textures/painted.jpg'),
    lengthRepeatScale: 0.01,
    heightRepeatScale: 0.01,
    normal: {
      uri: require('./textures/painted-normal.jpg'),
      lengthRepeatScale: 0.01,
      heightRepeatScale: 0.01,
      normalScaleX: 0.4,
      normalScaleY: 0.4
    }
  },
};

export default ElementsFactories.WallFactory('wall', info, textures);

